import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { tenantName } from '../../../constants/literals';
import { isRtl } from '../../../utils/rtlUtils';

export default function PageProps({ title, description }) {
  const intl = useIntl();
  return (
    <Helmet
      htmlAttributes={{
        lang: intl.locale,
        dir: isRtl(intl.locale) ? 'rtl' : 'ltr',
      }}
    >
      <title>
        {tenantName} | {`${intl.formatMessage({ id: title })}`}
      </title>
      <meta
        name="description"
        content={`${intl.formatMessage({ id: description })}`}
      />
    </Helmet>
  );
}
